export enum FormStatus {
  Editing = 'Editing',
  InFlight = 'InFlight',
  Succeeded = 'Succeeded',
  Failed = 'Failed',
  InvalidToken = 'InvalidToken',
  ExpiredNewUserToken = 'ExpiredNewUserToken',
}

export enum RequestStatus {
  InvalidParams = 'InvalidParams',
  Pending = 'Pending',
  Failed = 'Failed',
  Succeeded = 'Succeeded',
}
